
export const pages = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
    { name: "Illustrations", path: "/illustrations" },
    { name: "Print Projects", path: "/print-projects" },
    { name: "Digital Projects", path: "/digital-projects" },
  ];
  